var _style, _symbol, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaws(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DARK__BG_copy_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 351.5 71",
    style: {
      enableBackground: "new 0 0 351.5 71"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D9D9D9;}\n\t.st1{fill:none;}\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "paw",
    viewBox: "-10 -11.1 20 22.3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-9.2-5.9C-11-3.9-9.5-1.1-7.7-0.4C-5.2-0.1-3.5,0.2-1.6,1c1.9,0.7,4.1-0.2,4.2-2.5C2.6-2.8,2.4-4,3.1-5.4 C4-6.7,4.3-8.1,3.8-9.5c-0.4-1.1-1.2-1.5-2.3-1.6c-1.4-0.1-2.4,0.7-3.4,1.5C-2.2-9.3-2.6-9-2.9-8.7c-1,0.8-2.1,1.3-3.4,1.3 C-7.5-7.3-8.4-6.9-9.2-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.9,1.2c0.9,0.5,1.7,0.2,1.9-0.8c0.4-2,0.3-3.8-1.1-5.4C7.8-6.1,6.1-6.4,5-5.9C4-5.5,3.4-4.2,3.5-3.1 c0.1,0.8,0.6,1.3,1.1,1.8C5-0.9,7.1,0.8,7.9,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.3,2C6.4,1.4,5.6,1.1,4.7,1.3C3.4,1.4,2.6,2.7,3.1,4.1C3.4,4.9,4,5.7,4.4,6.4c0.4,0.6,0.8,1.3,1.2,1.9 C6,8.8,6.4,9.2,7,9.2c0.7-0.1,1.1-0.5,1.3-1.1C8.5,7.6,8.6,7,8.6,6.5C8.4,5.3,8.2,4.1,7.9,3C7.8,2.6,7.4,2.2,7.3,2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-0.8,4.8c-1.4,1.7-0.6,4.7,1.5,5.6c0.9,0.4,1.8,0.6,2.8,0.7c0.8,0.1,1.3-0.4,1.1-1.2C4.1,8.1,3.5,6.4,2.4,5 C1.5,3.7,0.1,3.6-0.8,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-3.5,1.6c-1.7-1.3-4-0.6-4.3,1.3c-0.1,0.9,0.2,1.6,0.6,2.3c0.8,1.2,1.9,2,3.2,2.5C-3.5,8-3.1,7.9-2.8,7.5 c0.9-1.4,0.7-4.4-0.4-5.6C-3.3,1.8-3.4,1.7-3.5,1.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(0.6027 0.245 0.245 -0.6027 300.3134 35.6729)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(0.8193 0.4193 0.4193 -0.8193 79.2812 24.4604)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(0.9321 0.3583 0.3583 -0.9321 336.8775 26.42)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(2.285363e-02 -1.0457 -1.0457 -2.285363e-02 170.78 34.6813)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(-0.221 -0.7044 -0.7044 0.221 219.9638 27.7859)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(0.9103 -0.2694 -0.2694 -0.9103 126.6721 30.5646)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(0.9571 -3.500415e-02 -3.500415e-02 -0.9571 261.7559 44.0475)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#paw",
    width: 20,
    height: 22.3,
    x: -10,
    y: -11.1,
    transform: "matrix(-0.1624 -1.0323 -1.0323 0.1624 22.8232 44.4083)",
    style: {
      overflow: "visible",
      opacity: 0.3
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 351.5,
    height: 71
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaws);
export default __webpack_public_path__ + "static/media/paws.7d0270a06c6a2461846e9fe96623ef5b.svg";
export { ForwardRef as ReactComponent };